<template>
  <div>
    <!-- Preview photo -->
    <div class="flex flex-col justify-center items-center gap-y-5 mt-10">
      <span v-if="currentImage != null" class="flex flex-col justify-center items-center w-full">
        <label v-if="props.typeImage == 'profile'" for="labelFile">
          <img :src="props.currentImage" class="w-36 h-36 mt-2 rounded-full border-2 border-gray-400" />
        </label>
        <label v-else for="labelFile" class="w-full">
          <img :src="props.currentImage" class="w-full h-36 mt-2" />
        </label>
        <label for="labelFile" class="font-medium mt-4">{{ translate('select a new image to update', 'ucfirst') }}</label>
      </span>
      <span v-else-if="preview" class="flex flex-col justify-center items-center w-full">
        <label v-if="props.typeImage == 'profile'" for="labelFile">
          <img :src="preview" class="w-36 h-36 mb-4 rounded-full border-2 border-gray-400" />
        </label>
        <label v-else for="labelFile" class="w-full mb-4">
          <img :src="preview" class="w-full h-36 mt-2" />
        </label>
        <p>{{ fileInfo.name }}</p>
        <p>{{ returnFileSize(fileInfo.size) }}</p>
      </span>
      <div v-else class="flex flex-col justify-center items-center w-full">
        <label v-if="props.typeImage == 'profile'" for="labelFile" class="w-36 h-36 rounded-full block border-2 border-gray-400"></label>
        <label v-else for="labelFile" class="w-full h-36 block bg-iron border border-gray-300"></label>
        <p class="font-medium mt-4">{{ translate('select your image to upload', 'ucfirst') }}</p>
      </div> 
    </div>
    <div>
      <label for="labelFile" :class="props.class">{{ translate(props.label, 'ucfirst') }}</label>
      <input :type="props.type" :name="props.name" :accept="props.accept" :multiple="props.multiple" id="labelFile"
        @change="handleFileChange" />
    </div>
    <span class="text-center block text-red-600">{{ error }}</span>
  </div>
</template>
<script setup>
import { ref, watch, onMounted } from "vue"
import { translate } from "@/composables/translate";


const emit = defineEmits(['uploadData'])
const props = defineProps({
  type: {
    type: String,
    required: false,
    default: 'file'
  },
  name: {
    type: String,
    required: false,
    default: ''
  },
  accept: {
    type: String,
    required: false,
    default: 'image/*'
  },
  label: {
    type: String,
    required: false
  },
  class: {
    type: String,
    required: false,
    default: ''
  },
  multiple: {
    type: Boolean,
    required: false,
    default: false
  },
  dynamicError: {
    type: String,
    required: false,
    default: ''
  },
  currentImage: {
    type: String,
    required: false,
    default: null
  },
  typeImage: {
    type: String,
    required: false
  }
});


let currentImage = ref(null)
let preview = ref(null)
let error = ref()
let fileInfo = ref({}) 
let Max_Size_MB = 1
const ALLOWED_TYPES = [
  "image/png", "image/jpg", "image/jpeg", "image/webp"
]

function handleFileChange(event) {
  const file = event.target.files[0];
  preview.value = null
  error.value = ''

  if (!file) return

  if (!ALLOWED_TYPES.includes(file.type)) {
    error.value = translate('invalid image format', 'ucfirst')
    return
  }

  if (file.size > Max_Size_MB * 1000 * 1000) {
    error.value = translate('the image must be a maximum of 1 Mb', 'ucfirst')
    return
  }

  fileInfo.value = file
  currentImage.value = null

  const reader = new FileReader()
  reader.onload = () => preview.value = reader.result
  reader.readAsDataURL(file)
  emit('uploadData', file)
}

function returnFileSize(number) {
  if (number < 1e3) {
    return `${number} bytes`;
  } else if (number >= 1e3 && number < 1e6) {
    return `${(number / 1e3).toFixed(1)} KB`;
  }
  return `${(number / 1e6).toFixed(1)} MB`;
}

watch(() => props.dynamicError, (newValue) => {
  error.value = newValue
});

onMounted(() => {
  setTimeout(() => {
    currentImage.value = props.currentImage
  }, 1000);
})
</script>
<style scoped>
input[type="file"] {
  display: none;
}

label {
  text-align: center;
  cursor: pointer;
}

.background-style {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
</style>
